import * as PIXI from 'pixi.js'
// import glslify from 'glslify'

let maskVS = require('../../glsl/fragments/default-filter-matrix.glsl')
let maskFS = require('../../glsl/mask/mask_fs.glsl')

export default class MaskFilter extends PIXI.Filter {
  constructor (sprite) {
    const maskMatrix = new PIXI.Matrix()

    super(
      maskVS,
      maskFS
    )

    this.resolution = PIXI.settings.RESOLUTION
    sprite.renderable = false

    this.maskSprite = sprite
    this.maskMatrix = maskMatrix
  }

  apply (filterManager, input, output) {
    const maskSprite = this.maskSprite

    this.uniforms.mask = maskSprite._texture
    this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite)

    filterManager.applyFilter(this, input, output)
  }
}



/** WEBPACK FOOTER **
 ** ./src/filters/Mask/MaskFilter.js
 **/